import MessageIcon from '@mui/icons-material/Message';
import { Grid } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import * as React from 'react';
import AssessmentSettings from './Components/AssessmentSettings';
import ContentBox from './Components/ContentBox';
import LinkTile from './Components/LinkTile';
import NotationManagementSettings from './Components/NotationManagementSettings';
import SettingsGroup from './Components/SettingsGroup';
import UserManagementSettings from './Components/UserManagementSettings';
import { IViewAllSettings } from './Interfaces/IViewAllSettings';

const useStyles = makeStyles({
  linkTileIcon: {
    fontSize: '40px',
  },
  linkTileText: {
    lineHeight: '1.2',
  },
});

const ViewAllSettings = (props: IViewAllSettings) => {
  const classes = useStyles();
  return (
    <ContentBox title="Settings">
      <Grid container direction="column" spacing={4}>
        <Grid item>
          <UserManagementSettings
            linkIconTileClassName={classes.linkTileIcon}
          />
        </Grid>
        <Grid item>
          <NotationManagementSettings
            linkIconTileClassName={classes.linkTileIcon}
          />
        </Grid>
        <Grid item>
          <AssessmentSettings linkIconTileClassName={classes.linkTileIcon} />
        </Grid>
        <Grid item>
          <SettingsGroup title="Defaults">
            <LinkTile
              href="/beacon/settings/systemmessages"
              text="Default System Messages"
            >
              <MessageIcon fontSize="large" />
            </LinkTile>
          </SettingsGroup>
        </Grid>
      </Grid>
    </ContentBox>
  );
};

export default ViewAllSettings;
